<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.2857 28.2625C37.2857 28.9 36.0714 29.325 34.6548 29.5375C33.744 27.7313 31.9226 26.35 29.7976 25.3937C30 25.075 30.2024 24.8625 30.4048 24.5438H31.2143C34.3512 24.4375 37.2857 26.4563 37.2857 28.2625V28.2625ZM19.881 24.4375H19.0714C15.9345 24.4375 13 26.4563 13 28.2625C13 28.9 14.2143 29.325 15.631 29.5375C16.5417 27.7313 18.3631 26.35 20.4881 25.3937L19.881 24.4375V24.4375ZM25.1429 25.5C27.369 25.5 29.1905 23.5875 29.1905 21.25C29.1905 18.9125 27.369 17 25.1429 17C22.9167 17 21.0952 18.9125 21.0952 21.25C21.0952 23.5875 22.9167 25.5 25.1429 25.5ZM25.1429 26.5625C20.994 26.5625 17.0476 29.325 17.0476 31.875C17.0476 34 25.1429 34 25.1429 34C25.1429 34 33.2381 34 33.2381 31.875C33.2381 29.325 29.2917 26.5625 25.1429 26.5625ZM30.9107 23.375H31.2143C32.9345 23.375 34.25 21.9938 34.25 20.1875C34.25 18.3812 32.9345 17 31.2143 17C30.7083 17 30.3036 17.1063 29.8988 17.3188C30.7083 18.3813 31.2143 19.7625 31.2143 21.25C31.2143 21.9937 31.1131 22.7375 30.9107 23.375ZM19.0714 23.375H19.375C19.1726 22.7375 19.0714 21.9937 19.0714 21.25C19.0714 19.7625 19.5774 18.3813 20.3869 17.3188C19.9821 17.1063 19.5774 17 19.0714 17C17.3512 17 16.0357 18.3812 16.0357 20.1875C16.0357 21.9938 17.3512 23.375 19.0714 23.375Z"
      fill="#80B7FF"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [Number, String], default: 50 },
    height: { type: [Number, String], default: 50 },
    color: { type: String, default: "#80B7FF" },
  },
};
</script>

<style>
</style>
